export enum QRType {
    INSU = 'insu',
    MY_ASSET = 'myAsset',
    REMIT = 'remit',
}

const QRBridgeTitle = {
    [QRType.INSU]: (
        <>
            QR코드를 찍어
            <br />
            모바일로 내 보험을 만나보세요
        </>
    ),
    [QRType.MY_ASSET]: (
        <>
            QR코드를 찍어
            <br />
            모바일로 내 자산을 만나보세요
        </>
    ),
    [QRType.REMIT]: (
        <>
            QR코드를 찍어
            <br />
            모바일로 송금을 만나보세요
        </>
    ),
}
export default QRBridgeTitle
